import Mustache from 'mustache';

import {
  BRACKET_ERROR,
  CHARS_TO_SUGGEST_SWITCHING_TO_EMAIL,
  EMAIL_SUGGESTION_WARNING,
  LONGEST_ALLOWABLE_TEXT,
  LONG_TEXT_MESSAGE_ERROR,
  REQUIRED_SUBJECT_TEXT,
} from './message-composer-constants';

import { MESSAGE_TYPE, MessageType } from '../../../util/message-types';

export const checkSubjectForErrors = (type: MessageType, subject: string | null) => {
  if (type !== MESSAGE_TYPE.EMAIL) {
    return null;
  }

  if (!subject?.trim()) {
    return REQUIRED_SUBJECT_TEXT;
  }

  if (subject) {
    try {
      Mustache.parse(subject);
    } catch (err) {
      return BRACKET_ERROR('subject');
    }
  }

  return null;
};

export const checkMessageForErrorsAndWarnings = (type: MessageType, newMessage: string) => {
  const returnObj: { error: string | null; warning: string | null } = {
    error: null,
    warning: null,
  };
  if (type === MESSAGE_TYPE.TEXT && newMessage.length >= LONGEST_ALLOWABLE_TEXT) {
    returnObj.error = LONG_TEXT_MESSAGE_ERROR;
  } else if (
    type === MESSAGE_TYPE.TEXT &&
    newMessage.length >= CHARS_TO_SUGGEST_SWITCHING_TO_EMAIL
  ) {
    returnObj.warning = EMAIL_SUGGESTION_WARNING;
  }

  try {
    Mustache.parse(newMessage);
  } catch (err) {
    returnObj.error = BRACKET_ERROR('message');
  }

  return returnObj;
};
